import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaMinus, FaPlus, FaChartLine, FaBalanceScale, FaNetworkWired, FaHeadset, FaSync, FaHospital, FaDollarSign, FaProjectDiagram, FaClipboardCheck, FaSyncAlt, FaCheckCircle, FaCodeBranch, FaLaptopMedical, FaChartBar, FaLifeRing, FaCog, FaBookMedical, FaClock,} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Hl7 = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">HL7 Healthcare Integration</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs ,We provide end-to-end HL7 integration solutions to streamline healthcare data exchange, ensuring seamless communication between EHR systems, LIS, RIS, PACS, and other healthcare applications. Our expertise in HL7 v2, HL7 v3, and FHIR enables organizations to achieve real-time interoperability, data accuracy, and compliance.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-300 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Secure and efficient healthcare data exchange is vital.
                            We simplify integration, ensuring accuracy, compliance, and seamless connectivity.
                        </p>


                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>


                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Standardized Data Exchange",
        description: "Enable smooth HL7-based communication between various healthcare systems, ensuring structured and efficient data transfer across platforms.",
        icon: FaExchangeAlt
    },
    {
        title: "Interoperability Enhancement",
        description: "Seamlessly connect hospitals, clinics, laboratories, pharmacies, and insurers to facilitate real-time data sharing and improve healthcare coordination.",
        icon: FaNetworkWired
    },
    {
        title: "FHIR Implementation",
        description: "Modernize legacy HL7 interfaces with advanced FHIR-based APIs, providing real-time data access and improved compatibility with evolving healthcare technologies.",
        icon: FaCodeBranch
    },
    {
        title: "Error-Free Data Transmission",
        description: "Reduce data mismatches, eliminate manual entry errors, and enhance workflow efficiency with automated, rule-based data transmission processes.",
        icon: FaCheckCircle
    },
    {
        title: "Regulatory Compliance",
        description: "Ensure full compliance with HIPAA, HL7, and FHIR regulations, maintaining the highest standards of security and structured data sharing.",
        icon: FaBalanceScale
    },
    {
        title: "Automated Data Validation",
        description: "Enhance data integrity by implementing automated validation checks, ensuring accurate and consistent information across healthcare systems.",
        icon: FaClipboardCheck
    },
    {
        title: "Real-Time Data Synchronization",
        description: "Enable instant updates and synchronization of patient records across multiple healthcare platforms, reducing delays in critical decision-making.",
        icon: FaSyncAlt
    },
    {
        title: "Cross-Platform Compatibility",
        description: "Ensure seamless integration across diverse healthcare applications, including web, mobile, and cloud-based solutions, for enhanced accessibility and usability.",
        icon: FaLaptopMedical
    }
];


const services = [

    {
        title: "HL7 Interface Development",
        description: "Develop and customize HL7 interfaces to ensure seamless data exchange between disparate healthcare systems, improving interoperability and efficiency.",
        icon: FaCodeBranch
    },
    {
        title: "HL7 & FHIR API Integration",
        description: "Implement HL7 v2, HL7 v3, and FHIR-based APIs to enable secure, real-time data sharing across modern healthcare applications.",
        icon: FaExchangeAlt
    },
    {
        title: "EHR & LIS Connectivity",
        description: "Facilitate bi-directional data exchange between hospitals, laboratories, pharmacies, and other healthcare providers to streamline workflows.",
        icon: FaHospital
    },
    {
        title: "Message Transformation & Mapping",
        description: "Convert HL7 messages such as ADT, ORU, and MDM into standardized formats for compatibility with various healthcare platforms.",
        icon: FaSync
    },
    {
        title: "Automated Workflow Optimization",
        description: "Reduce manual intervention by automating data routing, patient record updates, and clinical decision support processes.",
        icon: FaCog
    },
    {
        title: "Custom Middleware Solutions",
        description: "Develop middleware to integrate legacy healthcare systems with modern cloud-based platforms for better scalability and performance.",
        icon: FaNetworkWired
    },
    {
        title: "24/7 Monitoring & Support",
        description: "Provide real-time troubleshooting, system updates, and performance enhancements to ensure uninterrupted healthcare operations.",
        icon: FaLifeRing
    },
    {
        title: "Healthcare Data Analytics",
        description: "Leverage AI-driven analytics to gain insights into patient trends, operational efficiencies, and clinical decision-making.",
        icon: FaChartBar
    },
    {
        title: "Interoperability Testing & Validation",
        description: "Ensure seamless data exchange by conducting thorough interoperability testing, validating HL7, FHIR, and custom API integrations.",
        icon: FaCheckCircle
    }
];

const whyChooseUs = [
    {
        title: "Extensive HL7 Expertise",
        description: "Leverage deep knowledge of HL7, FHIR, CCD, and CDA standards to ensure accurate and efficient healthcare data exchange.",
        icon: FaBookMedical
    },
    {
        title: "End-to-End Security",
        description: "Ensure secure data transmission with encryption, role-based access controls, and authentication measures to protect patient information.",
        icon: FaShieldAlt
    },
    {
        title: "Seamless System Interoperability",
        description: "Enable smooth connectivity between EHRs, LIS, RIS, PACS, and other healthcare platforms for improved workflow automation.",
        icon: FaProjectDiagram
    },
    {
        title: "Scalable & Future-Ready Solutions",
        description: "Implement flexible and scalable integrations designed to adapt and grow with your healthcare organization's evolving needs.",
        icon: FaChartLine
    },
    {
        title: "Regulatory Compliance Assurance",
        description: "Meet industry regulations such as HIPAA, ONC, and the HITECH Act with fully compliant data exchange solutions.",
        icon: FaBalanceScale
    },
    {
        title: "Customizable & Cost-Effective",
        description: "Develop tailored, budget-friendly integration solutions that align with your specific healthcare requirements.",
        icon: FaDollarSign
    },
    {
        title: "Real-Time Data Access",
        description: "Enable instant access to critical healthcare data for better decision-making and patient care.",
        icon: FaClock
    },
    {
        title: "24/7 Support & Monitoring",
        description: "Ensure seamless operations with round-the-clock support, proactive monitoring, and quick issue resolution.",
        icon: FaHeadset
    }
];

const List = [
    
        {
            "title": "HL7 Message Processing & Parsing",
            "description": "Efficiently process, parse, and manage HL7 messages, including ADT (Admission, Discharge, Transfer), ORM (Order Entry), ORU (Observation Reports), MDM (Medical Document Management), and VXU (Vaccination Updates). Our solutions ensure seamless and accurate data exchange between healthcare systems while maintaining compliance with industry standards.",
            "icon": "FaExchangeAlt"
        },
        {
            "title": "FHIR API Implementation",
            "description": "Develop and implement FHIR-based APIs to facilitate fast, secure, and standardized healthcare data exchange. Our solutions support patient data retrieval, medical record updates, and interoperability with EHRs, mobile health apps, and third-party platforms, ensuring real-time and efficient communication.",
            "icon": "FaCodeBranch"
        },
        {
            "title": "Legacy System Modernization",
            "description": "Upgrade outdated HL7 interfaces and healthcare data exchange systems with modern integration frameworks. We enhance compatibility with the latest healthcare IT standards, ensuring interoperability with cloud-based applications, EHRs, and emerging digital health technologies.",
            "icon": "FaRedo"
        },
        {
            "title": "Cross-Platform Compatibility",
            "description": "Facilitate seamless HL7 and FHIR data exchange between web, mobile, and cloud-based applications. Our solutions ensure flexibility, scalability, and secure access to healthcare data from any device, enhancing usability and efficiency across multiple platforms.",
            "icon": "FaCloud"
        },
        {
            "title": "Healthcare Data Interoperability",
            "description": "Integrate hospitals, laboratories, imaging centers, and pharmacies within a unified digital ecosystem. Our interoperability solutions streamline workflows, reduce administrative burdens, and ensure efficient, error-free data sharing for enhanced patient care.",
            "icon": "FaHospital"
        },
        {
            "title": "Continuous Support & Maintenance",
            "description": "Ensure uninterrupted system performance with 24/7 monitoring, proactive bug fixes, and optimization. We provide regular software updates, troubleshoot HL7 messaging issues, and ensure smooth healthcare data exchange with minimal downtime.",
            "icon": "FaTools"
        },
        {
            "title": "Custom HL7 Message Mapping",
            "description": "Seamlessly convert and map HL7 messages between different formats, ensuring accurate and efficient data translation across healthcare systems. Our customized message transformation solutions support integration with EHRs, HIEs, and third-party healthcare applications.",
            "icon": "FaMap"
        },
        {
            "title": "Automated Workflow Integration",
            "description": "Reduce manual intervention by automating critical healthcare workflows such as patient data entry, lab order processing, results reporting, and medical document management. Our workflow automation solutions increase efficiency, accuracy, and compliance.",
            "icon": "FaCog"
        },
        {
            "title": "Security & Compliance Assurance",
            "description": "Ensure full compliance with HIPAA, ONC, and FHIR security standards through encrypted data exchanges, secure authentication, and role-based access controls. Our solutions protect patient health information (PHI) while maintaining regulatory compliance.",
            "icon": "FaLock"
        }
    ]
    


export default Hl7;
